export default "__VITE_ASSET__20beccbe__"